// src/components/0.Utilidades/loadingSpinner.js
import React from "react";
import { Spinner } from "react-bootstrap";

const CargandoSpinner = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100%", width: "100%", minHeight: "200px" }}
    >
      <Spinner animation="border" role="status"></Spinner>
    </div>
  );
};

export default CargandoSpinner;
